module.exports = __webpack_public_path__ + "static/media/5.Engine Operated Mini Sprayer.8edfb3d6.jpg";